import { Box, Grid, Theme, Typography } from "@mui/material"

export const DropZoneModal = (props: { isDragActive: boolean }) => {
	return (
		<Box
			className={props.isDragActive === true ? "active" : ""}
			sx={(theme: Theme) => ({
				position: "absolute",
				top: 0,
				left: 0,
				width: "100vw",
				height: "100vh",
				zIndex: -1,
				"&.active": {
					zIndex: theme.zIndex.modal + 1,
					backgroundColor: "rgba(0,0,0,0.5)",
				},
				padding: 2,
			})}
		>
			<Grid
				container
				alignItems="center"
				justifyContent="center"
				sx={{
					height: "100%",
					border: "6px dashed white",
					borderRadius: "20px",
					visibility: props.isDragActive ? "visible" : "hidden",
				}}
			>
				<Grid item>
					<Typography color="white" fontWeight="bold" fontSize="40px">
						CSV ファイルをドロップします
					</Typography>
				</Grid>
			</Grid>
		</Box>
	)
}
